import React, { FC, useCallback } from "react";

import { useDataLayer } from "../../hooks/use-data-layer";
import { ReactComponent as BiesseLogo } from "../../images/biesse-logo.svg";
import { GoogleAnalyticsEvent } from "../../utils/analytics";
import { IconButton } from "../buttons/icon-button";
import { FooterProps } from "./footer";

export type FooterTopProps = Pick<
  FooterProps,
  "facebookUrl" | "youtubeUrl" | "linkedinUrl" | "instagramUrl"
>;

export const FooterTop: FC<FooterTopProps> = ({
  facebookUrl,
  youtubeUrl,
  linkedinUrl,
  instagramUrl,
}) => {
  const { pushEvent } = useDataLayer();
  const onPushEvent = useCallback(
    (type: string) => {
      pushEvent({
        event: GoogleAnalyticsEvent.ClickFooter,
        footer_action: type,
      });
    },
    [pushEvent]
  );

  return (
    <div className="flex flex-col lg:flex-row w-full gap-10 lg:gap-0 lg:justify-between items-center lg:items-baseline lg:mb-14">
      <BiesseLogo className="flex-shrink-0 w-[160px] text-light" />
      <div className="flex gap-5">
        {facebookUrl && (
          <a
            href={facebookUrl}
            onClick={() => onPushEvent(GoogleAnalyticsEvent.Facebook)}
            target="_blank"
            rel="noreferrer"
          >
            <IconButton icon="facebook" variant="light-outline" />
          </a>
        )}
        {instagramUrl && (
          <a
            href={instagramUrl}
            onClick={() => onPushEvent(GoogleAnalyticsEvent.Instagram)}
            target="_blank"
            rel="noreferrer"
          >
            <IconButton icon="instagram" variant="light-outline" />
          </a>
        )}
        {linkedinUrl && (
          <a
            href={linkedinUrl}
            onClick={() => onPushEvent(GoogleAnalyticsEvent.Linkedin)}
            target="_blank"
            rel="noreferrer"
          >
            <IconButton icon="linkedin" variant="light-outline" />
          </a>
        )}
        {youtubeUrl && (
          <a
            href={youtubeUrl}
            onClick={() => onPushEvent(GoogleAnalyticsEvent.Youtube)}
            target="_blank"
            rel="noreferrer"
          >
            <IconButton icon="youtube" variant="light-outline" />
          </a>
        )}
      </div>
    </div>
  );
};
